export const environment = {
    production: false,
    apiService_Auth: '/backend-login',
    apiService: '/backend-soporte',
    apiService_Erp: '/backend-erp',
    apiService_Report: '/backend-report',
    apiService_Produccion: '/backend-prod-api',
    apiService_Adjuntos: '/backend-adjuntos',
    apiService_FE: '/backend-fe',
    apiService_Notificaciones: '/backend-notification',
    apiService_Config: '/backend-config',
    recaptcha: {
        siteKey: '6LdqZT0sAAAAAHAFBX8eo0fXQKCHYhd9C6IoY7UZ',
    },
    URL_CONFIGURACION: 'url_configuracion',
    PRODUCTO: 'RECURSOS',
    NEW_TSI_APP: 'url_new_erp',
    NEW_TSI_APP_URL: 'url_new_erp_app',
    TSI_DECLARACIONES_TRIBUTOS: 'url_declaraciones_tributos'
}